<button mat-button data-test="edit" class="edit" color="primary" (click)="edit.emit()">
  <span class="material-icons edit__icon">edit</span>
  Editar
</button>